import { Bundle } from "@greeter/core";
import { mockProduct } from "./MockProduct";

/**
 * A bundle with no lines
 */
export const mockBundle: Bundle = {
  ...mockProduct,
  isPublic: true,
  lines: [],
};
